/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TrackOfTheWeek from './TrackOfTheWeek.js';
import Trending from './Trending.js';
import FeaturedArtist from './FeaturedArtist.js';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as artistActions from '../../actions/artistActions';
import * as trackActions from '../../actions/trackActions';
import * as browserCheck from '../../utils/browserCheck.js';
import Search from './Search.js';

class HomePage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.playPause = this.playPause.bind(this);
        this.goto = this.goto.bind(this);
        /*this.state = 
        { 
            featuredArtists: this.state.artists.featuredArtists
        };  */   
    }

    componentWillMount() {
        this.loadFeaturedArtists();    
        this.loadFeaturedTracks();        
        this.loadCharts();
    }

    componentDidMount() {  
        if (browserCheck.canUseDom()) {
            const {WOW} = require('wowjs');
            if(typeof(WOW) != 'undefined') {
                new WOW().init();
            }
            let heroSlider = $('.hero-slider', $('#hero'));
            if (heroSlider.length != 0) {
                require('../../scripts/slick.min.js');
                heroSlider.on('init', function (event, slick, direction) {
                    heroSlider.addClass('heroimgslider-active');
                });
        
                heroSlider.slick({
                    dots: false,
                    autoplay: true,
                    speed: 1500,
                    autoplaySpeed: 4000,
                    arrows: false,
                    draggable: false,
                    infinite: true,
                    pauseOnFocus: false,
                    pauseOnHover: false,
                    swipe: false,
                    fade: true
                });

                heroSlider.find('.hero-slide').show();
            }
        }        
    }

    goto(url) {        
        this.props.history.push(url);
    }

    playPause(event, trackID) {
        event.preventDefault();
        this.props.actions.playPauseTrack(trackID);
    }

    loadFeaturedArtists() { 
        if(this.props.featuredArtists.length == 0) {
            this.props.actions.getFeaturedArtists();
        }
    }

    loadFeaturedTracks() {     
        if(this.props.featuredTracks.length == 0) {
            this.props.actions.getFeaturedTracks();
        }
    }

    loadCharts() {     
        if(this.props.charts.length == 0) {
            this.props.actions.getCharts();
        }
    }

    render() {
        return (
            <div id="content">  
                <div id="hero" className="hero">
                    <div className="hero-slider"> 
                        <div className="hero-slide" style={{backgroundImage: `url(${require('../../images/hero-1.jpg')})`}} />
                        <div className="hero-slide" style={{backgroundImage: `url(${require('../../images/hero-2.jpg')})`, display: 'none'}} />
                        <div className="hero-slide" style={{backgroundImage: `url(${require('../../images/hero-3.jpg')})`, display: 'none'}} />
                        <div className="hero-slide" style={{backgroundImage: `url(${require('../../images/hero-4.jpg')})`, display: 'none'}} />
                    </div>

                    <div className="hero-content">
                        <div className="hero-msg">
                            <div className="hero-search">
                                <h1>Discover new music by independent artists</h1>
                                <p className="hero-intro">Type in your favourite artist or genre to get started</p>
                                <form className="form form-herosearch">
                                    <div className="form-group">
                                        <Search />                                       
                                    </div>
                                </form>
                                <p className="hero-tag">#rebelagainsttheradio</p>
                            </div>
                        </div>
                        <div className="hero-featured">
                            <div className="container">
                                <div className="row">
                                    <div className="col-xs-6">
                                        <p className="hero-head">Featured Artists</p>
                                    </div>
                                    <div className="col-xs-6 text-right">
                                        <button className="btn btn-outline btn-explore transition" onClick={() => this.goto('/Artists')}>
                                            EXPLORE
                                            <svg className="icon icn-carret transition">
                                                <use xlinkHref="#icn-carret" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <ul id="ulFeaturedArtists" className="list-inline covers covers-inline covers-material">
                                    {this.props.featuredArtists.map(artist =>
                                        <FeaturedArtist key={artist.Username} artist={artist} />
                                    )}  
                                </ul>
                            </div>
                        </div>                         
                    </div>
                </div>

                <div id="hcontent" className="hcontent">
                    <div className="hblock wow land animated" data-wow-delay="0s">
                        <div className="hintro">
                            <img className="picto" src={require('../../images/picto-loudup-home.png')} alt="LoudUp is a global music social network connecting independent artists to music enthusiasts" />
                            <h1>LoudUp is a global music social network connecting independent artists to music enthusiasts. Find out <a href="/HowItWorks">how we work here</a>.</h1>
                            <p className="intro">Like what you hear? Turn it up! <span><a href="https://twitter.com/search?f=realtime&q=%23rebelagainsttheradio%20from%3Aloudupofficial&src=typd" target="_blank">#rebelagainsttheradio</a></span></p>
                        </div>
                    </div>

                    {this.props.featuredTracks.length > 0 ? <TrackOfTheWeek track={this.props.featuredTracks[0]} goto={this.goto} /> : null}
                    <Trending charts={this.props.charts} playPause={this.playPause} goto={this.goto} />
                    
                    <div className="hblock wow land animated" data-wow-delay="0.5s">
                        <h4 className="section-alt">Ready to start connecting?</h4>
                        <ul className="list-unstyled list-hfeats">
                            <li>
                                <img className="picto" src={require('../../images/picto-fans-home.png')} alt="Discover new music! Find exciting, new, emerging artists and bands and connect with other music fans over a shared music taste" />
                                <h5>FANS</h5>
                                <p><a href="/Discover">Discover new music</a>! Find exciting, new, <a href="/Artists">emerging artists and bands</a> and connect with other music fans over a shared music taste</p>
                            </li>
                            <li>
                                <img className="picto" src={require('../../images/picto-artists-home.png')} alt="Showcase your music, connect with music producers, musicians, songwriters, promoters, venues, studios, managers and record labels" />
                                <h5>UNSIGNED ARTISTS</h5>
                                <p>Showcase your music, connect with <a href="/Producers">music producers</a>, <a href="/Musicians">musicians</a>, <a href="/Songwriters">songwriters</a>, <a href="/Promoters">promoters</a>, <a href="/Venues">venues</a>, <a href="/RecordingStudios">studios</a>, <a href="/Managers">managers</a> and <a href="/RecordLabels">record labels</a></p>
                            </li>
                        </ul>
                        <div className="ctablock">
                            <div className="btnout">
                                <Link to="/Account/Signup" className="btn btn-primary btn-block transition">CREATE A FREE ACCOUNT</Link>
                            </div>
                            <p>It takes just a couple of minutes</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HomePage.propTypes = {
    history: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    featuredArtists: PropTypes.array.isRequired,
    featuredTracks: PropTypes.array.isRequired,
    charts: PropTypes.array.isRequired
};

function mapStateToProps(state, ownProps) {
    return { featuredArtists: state.artists.featuredArtists, featuredTracks: state.tracks.featuredTracks, charts: state.tracks.charts, nowPlaying: state.tracks.nowPlaying, trackPlaying: state.tracks.trackPlaying } ;
}

function mapDispatchToProps(dispatch) {
    return {
        //artist and track actions will now be available under this.props.actions
        actions: bindActionCreators(Object.assign({}, artistActions, trackActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);